@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Mixins

@mixin waveBackground($baseColor) {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: wave;
  animation-timing-function: linear;
  background: $baseColor;
  background: linear-gradient(to right, $baseColor 8%, darken($baseColor, 3%) 18%, $baseColor 33%);
  background-size: 1000px 104px;
  height: 338px;
  position: relative;
  overflow: hidden;
}


// ================================================================ //
// -- Local Variables

$itemColor: #f3f2f2;
$darkerItemColor: darken($itemColor, 5%);
$backgroundColor: #f5f5f5;

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-loading-skeleton {

    .fluid-skeleton-circle {

      @mixin circle($diameter) {
        height: $diameter;
        width: $diameter;
      }

      background: $itemColor;
      border-radius: 100%;
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
      transform: scale(1);
      animation: pulse 2s infinite;

      &.xs {
        @include circle(20px)
      }

      &.sm {
        @include circle(40px)
      }

      &.md {
        @include circle(60px)
      }

      &.lg {
        @include circle(80px)
      }

      &.xl {
        @include circle(100px)
      }

    }

    .fluid-skeleton-rectangle {

      @mixin rectangle($height) {
        height: $height;
        width: 100%;
        display: block;

        &:not(.no-gutter) {
          margin: 3px;
        }
      }

      background-color: $itemColor;
      transform: scale(1);

      &.pulse {
        animation: pulse 2s infinite;
      }

      &.wave {
        @include waveBackground($itemColor);
        animation: wave 2s infinite;
      }

      &.darkened {
        background-color: $darkerItemColor;
        @include waveBackground($darkerItemColor);
      }

      &.xs {
        @include rectangle(15px)
      }

      &.sm {
        @include rectangle(25px)
      }

      &.md {
        @include rectangle(35px)
      }

      &.lg {
        @include rectangle(45px)
      }

      &.xl {
        @include rectangle(55px)
      }

    }

    .fluid-skeleton-image {
      border: 1px solid $itemColor;
      padding: 8px 5px 10px;
    }

    .fluid-skeleton-table-header {
      background-color: $backgroundColor;
      padding: 3px 2px;
    }

    .fluid-skeleton-table-body {
      padding: 1px;
    }

    .fluid-skeleton-card {
      border: 1px solid $itemColor;

      .fluid-skeleton-card-header {
        background-color: $backgroundColor;
        padding: 5px;
      }

      .fluid-skeleton-card-body {
        padding: 5px;
      }
    }

    .fluid-skeleton-form {
      margin: 1em 0;
      border: 1px dashed #cccbcb;
      padding: 1em;
    }

  }
}

@keyframes wave {
  from {
    background-position: -468px 0;
  }

  to {
    background-position: 468px 0;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }

  70% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(0.9);
  }
}

@keyframes loading {
  100% {
    transform: translateX(100%);
  }
}